import { render, staticRenderFns } from "./customerOrder.vue?vue&type=template&id=40f7732e&scoped=true&"
import script from "./customerOrder.vue?vue&type=script&lang=js&"
export * from "./customerOrder.vue?vue&type=script&lang=js&"
import style0 from "./customerOrder.vue?vue&type=style&index=0&id=40f7732e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7732e",
  null
  
)

export default component.exports